import React from 'react';
import Navbar from './global-components/navbar-v2';
import PageHeader from './global-components/page-header';
import CallToActionV1 from './section-components/call-to-action-v1';
import Footer from './global-components/footer';
import TopBar from './global-components/topbar';
import ConstructionInfo02 from './section-components/construction-info2';

const Construction02 = () => {
    return <div>
        <TopBar/>
        <Navbar />
        {/* <PageHeader headertitle="House Constructions" subheader="Constructions" /> */}
        <ConstructionInfo02 />
        <CallToActionV1 />
        <Footer />
    </div>
}

export default Construction02
